import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, to, href, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "inline-flex items-center justify-center px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300 rounded-sm";
  
  const variants = {
    primary: "bg-olive-grove text-white hover:bg-opacity-90 shadow-sm hover:shadow-md",
    secondary: "bg-transparent border border-estate-bronze text-estate-bronze hover:bg-estate-bronze hover:text-white",
    outline: "bg-transparent border border-deep-charcoal text-deep-charcoal hover:bg-deep-charcoal hover:text-white",
  };

  const classes = `${baseStyle} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;